//@ts-expect-error not typed yet
import Workflow from 'EmailData/models/Workflow';
import { getWorkflowEditUrlForSourceApp } from 'EmailComponents/utils/automation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WarningIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmailList({
  emailsWithWFInfo,
  shouldRenderWorkflow,
  isLoadingWorkflows
}) {
  if (isLoadingWorkflows) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(ExpandableText, {
      toggleable: false,
      scrollable: true,
      maxHeight: 200,
      children: /*#__PURE__*/_jsx(List, {
        styled: true,
        paddingInlineStart: "300",
        children: emailsWithWFInfo.map(emailWithFlows => {
          if (shouldRenderWorkflow && emailWithFlows.flows.length > 0) {
            return /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsxs(Flex, {
                flexDirection: "column",
                children: [emailWithFlows.emailName, /*#__PURE__*/_jsxs(Flex, {
                  flexDirection: "row",
                  children: [/*#__PURE__*/_jsx(View, {
                    paddingBlockStart: "50",
                    marginInlineEnd: "100",
                    children: /*#__PURE__*/_jsx(WarningIcon, {
                      size: "300",
                      color: "do-not-use-marigold-dark"
                    })
                  }), /*#__PURE__*/_jsxs(View, {
                    children: [/*#__PURE__*/_jsx(Text, {
                      color: "text-primary-subtle",
                      as: "span",
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "email-management.emailList.usedIn"
                      })
                    }), /*#__PURE__*/_jsx("span", {
                      children: "\xA0"
                    }), emailWithFlows.flows.map(flow => /*#__PURE__*/_jsxs(Text, {
                      as: "span",
                      children: [/*#__PURE__*/_jsx(Link, {
                        external: true,
                        href: getWorkflowEditUrlForSourceApp(Workflow.from(flow)),
                        children: flow.name
                      }), flow.id !== emailWithFlows.flows[emailWithFlows.flows.length - 1].id && /*#__PURE__*/_jsx("span", {
                        children: ",\xA0"
                      })]
                    }, flow.id))]
                  })]
                })]
              })
            }, emailWithFlows.emailName);
          }
          return /*#__PURE__*/_jsx(ListItem, {
            children: emailWithFlows.emailName
          }, emailWithFlows.emailName);
        })
      })
    })
  });
}